import { useDispatch } from 'react-redux';
import { BiEventType } from '../../biLogger/constants';
import { requestJoinGroup } from '../../redux/groups/actions';
import noop from '../noop';
import { useThrottle } from './useThrottle';
export function useGroupJoin(group) {
    var _a;
    var dispatch = useDispatch();
    // throttle those button presses so there's time for any notifications to disappear/backend requests to complete
    var requestJoinThrottled = useThrottle(function () { return dispatch(requestJoinGroup(group)); }, [dispatch, group], 6000);
    if ((_a = group.extendedGroup) === null || _a === void 0 ? void 0 : _a.isIngroup) {
        return {
            onClick: noop,
            biData: undefined,
        };
    }
    return {
        onClick: requestJoinThrottled,
        biData: { evid: BiEventType.JOIN_GROUP, groupid: group.useridUuid },
    };
}
//# sourceMappingURL=useGroupJoin.js.map